import { resetState } from '@/utils/Storage'

const initialState = ()=> {
    return  {
        bgComponent: 'DefaultBackground',
        bgColors: [],
        animateBGIfAvailable: true,
    }
}

export default {
  namespaced: true,
  state: {
    bgComponent: 'DefaultBackground',
    bgColors: [],
    animateBGIfAvailable: true,
  },
  mutations: {
    reset: (state) => {
      const s = initialState()
      resetState(state, s);
    },
    setBGComponent(state, payload) {
      state.bgComponent = payload
    },
    setBGColors(state, payload) {
      state.bgColors = payload
    },
    setAnimateBGIfAvailable(state, payload) {
      state.animateBGIfAvailable = payload
    }
  },
  actions: { }
}
